import { Flex } from "@/atoms"
import { useServices } from "@/hooks/useServices"
import { Fallback } from "@/molecules/Fallback"
import cn from "classnames"
import { lazy, Suspense, useEffect, useRef, useState } from "react"
import styles from "./TrialDaysExpired.module.scss"

const TrialDaysExpiredMessage = lazy(() => import("./TrialDaysExpiredMessage"))

const TrialDaysExpired = ({
  reject,
  children
}: {
  reject: React.MutableRefObject<(() => void) | undefined>
  children: React.ReactNode
}) => {
  const Steps = {
    EMPTY: 0,
    DASHBOARD: 1,
    EXPIRED: 2
  }
  const pageRef = useRef<HTMLDivElement>(null)
  const [step, setStep] = useState(Steps.EMPTY)
  const { auth } = useServices()

  const onExpiredTransitionEnd = () => {
    reject.current?.()
    auth.signOut()
  }

  useEffect(() => {
    if (!pageRef.current) return

    setStep(Steps.DASHBOARD)

    const onPageTransitionEnd = () => {
      setStep(Steps.EXPIRED)
    }

    pageRef.current.addEventListener("transitionend", onPageTransitionEnd)

    return () => {
      pageRef.current?.removeEventListener("transitionend", onPageTransitionEnd)
    }
  }, [])

  return (
    <>
      <Flex
        ref={pageRef}
        className={cn(styles.page, step !== Steps.EMPTY && styles.hidden)}
      >
        {children}
      </Flex>
      <Suspense fallback={<Fallback />}>
        <TrialDaysExpiredMessage
          className={step === Steps.EXPIRED && styles.visible}
          callback={onExpiredTransitionEnd}
        />
      </Suspense>
    </>
  )
}

export default TrialDaysExpired
